'use strict';

import BaseService from './base.service';

export default class ProvincesService extends BaseService {
  static $inject = ['Province', 'SegaUser'];

  constructor(Province, SegaUser) {
    super(Province, SegaUser);
    Object.assign(this, {
      Province
    });
  }
}
